import { styled } from '@acko-tech/building-blocks.ui.common';

export const Container = styled.div`
    min-height: 100px;
    > h6 {
        margin: 20px 0;
    }
`;

export const CTAContainer = styled.div`
    margin: 30px 0 8px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`;

export const Link = styled.span`
    font-weight: 500;
    font-size: 14px;
    color: #1b73e8;
`;

export const WarningMessage = styled.span`
    color: #4b4b4b;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 24px;
`;
